import { useEffect, useState } from 'react';
import { machineListCache } from 'App/Activity/MachineStateManager';
import { PowerState, SummaryState } from 'App/Activity/Network/ActionsUtil';
import {
	MachineData,
	useResourceManagerContext,
} from 'App/Activity/ResourceManagerContext';
import { isInMaintenanceMode } from 'App/Activity/Utility';
import { DesktopWallpaper, mapOSNameToType } from 'App/Tile/utils';
import { Resource } from 'Workspace/ResourceProvider/resourceTypes';

export interface DesktopDetails {
	desktopWallpaper: DesktopWallpaper;
	desktopOS?: string;
	maintenanceMode: boolean;
	maintenanceModeUserString?: string;
	summaryState?: SummaryState;
	lastLaunchedTime?: string;
	isUnderMaintenanceOrUnavailable: boolean;
	isLoading?: boolean;
}

export const useDesktopDetails = (resource: Resource): DesktopDetails => {
	const [desktopWallpaper, setDesktopWallpaper] = useState<DesktopWallpaper>('Unknown');
	const [desktopData, setDesktopData] = useState<MachineData>();
	const context = useResourceManagerContext();

	useEffect(() => {
		const machineData = machineListCache
			.getAllMachines()
			?.machines.find(machine => machine.resourceId === resource.id)?.machineData;
		setDesktopData(machineData);

		const getWallpaper = (): DesktopWallpaper => {
			if (context?.machineStatus?.loading) {
				return PowerState.LOADING as DesktopWallpaper;
			}
			if (isInMaintenanceMode(machineData)) {
				return 'UnderMaintenance';
			}
			if (machineData?.powerState === PowerState.UNAVAILABLE) {
				return PowerState.UNAVAILABLE as DesktopWallpaper;
			}
			return mapOSNameToType(machineData?.osType);
		};

		setDesktopWallpaper(getWallpaper());
	}, [context?.machineStatus?.loading, resource]);

	return {
		desktopWallpaper,
		desktopOS: desktopData?.osType,
		maintenanceMode: isInMaintenanceMode(desktopData),
		maintenanceModeUserString: desktopData?.maintenanceModeUserString,
		summaryState: desktopData?.summaryState,
		lastLaunchedTime: desktopData?.lastLaunchedTime,
		isUnderMaintenanceOrUnavailable:
			desktopWallpaper === 'Unavailable' || desktopWallpaper === 'UnderMaintenance',
		isLoading: context?.machineStatus?.loading,
	};
};
